import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uurwerk--power-bi"
    }}>{`Uurwerk & Power BI`}</h1>
    <p>{`Net begonnen of nieuwe computer? Lees hoe je Power BI in kunt stellen om Uurwerk te raadplegen in `}<a parentName="p" {...{
        "href": "/powerbi/start"
      }}>{`Aan de slag`}</a>{`.`}</p>
    <p>{`Opfrissen? Lees snel terug hoe je `}<a parentName="p" {...{
        "href": "/powerbi/how-to/filter-direction"
      }}>{`filterrichtingen instelt`}</a>{`, `}<a parentName="p" {...{
        "href": "/powerbi/how-to/waardes-samenvoegen"
      }}>{`schrijfwijzen kunt samenvoegen`}</a>{`, of `}<a parentName="p" {...{
        "href": "/powerbi/how-to/renaming"
      }}>{`veldnamen wijzigt`}</a>{`.`}</p>
    <p>{`De exacte betekenis van een veld nakijken? Die vind je terug op de pagina's over tabellen: `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/dienst"
      }}>{`Dienst`}</a>{`, `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/evenement"
      }}>{`Evenement`}</a>{`, `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/gepubliceerdrooster"
      }}>{`Gepubliceerd Rooster`}</a>{`, `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/medewerker"
      }}>{`Medewerker`}</a>{`.`}</p>
    <p>{`Benieuwd naar recente wijzigingen? Op de `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/changelog"
      }}>{`tabelwijzigingen`}</a>{`-pagina staan alle wijzigingen aan tabellen en velden.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Kan er iets beter? Dat horen we graag. `}</p>
      <p parentName="blockquote">{`Stuur je suggesties en ideeën in `}<a parentName="p" {...{
          "href": "https://uurwerk.zendesk.com/"
        }}>{`via je helpdesk`}</a>{`.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      